var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgFilterIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "16px",
    height: "16px",
    viewBox: "0 0 16 16",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Filter") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Design-V2",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Artboard",
    transform: "translate(-46.000000, -170.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "filter-icon",
    transform: "translate(46.000000, 170.000000)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    x: 0,
    y: 0,
    width: 16,
    height: 16
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.5,11.5 C12.0898401,11.5 12.6001639,11.8404498 12.8451867,12.3355649 L15,12.335 L15,13.665 L12.8447005,13.6654167 C12.5994893,14.16 12.0894503,14.5 11.5,14.5 C10.9105497,14.5 10.4005107,14.16 10.1552995,13.6654167 L1,13.665 L1,12.335 L10.1548133,12.3355649 C10.3998361,11.8404498 10.9101599,11.5 11.5,11.5 Z M4.5,6.5 C5.08984011,6.5 5.6001639,6.84044984 5.84518671,7.33556485 L15,7.335 L15,8.665 L5.84470053,8.66541667 C5.59948928,9.16000004 5.08945026,9.5 4.5,9.5 C3.91054974,9.5 3.40051072,9.16000004 3.15529947,8.66541667 L1,8.665 L1,7.335 L3.15481329,7.33556485 C3.3998361,6.84044984 3.91015989,6.5 4.5,6.5 Z M9.5,1.5 C10.0898401,1.5 10.6001639,1.84044984 10.8451867,2.33556485 L15,2.335 L15,3.665 L10.8447005,3.66541667 C10.5994893,4.16000004 10.0894503,4.5 9.5,4.5 C8.91054974,4.5 8.40051072,4.16000004 8.15529947,3.66541667 L1,3.665 L1,2.335 L8.15481329,2.33556485 C8.3998361,1.84044984 8.91015989,1.5 9.5,1.5 Z",
    id: "Combined-Shape",
    fill: "#000000",
    fillRule: "nonzero"
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFilterIcon);
export default __webpack_public_path__ + "static/media/filter-icon.7b483158.svg";
export { ForwardRef as ReactComponent };